export const environment = {
    production: true,
    server_address: 'https://homolog-docs.sccon.com.br/api',
    recaptchaSiteKey: '6LcjehwqAAAAAD44I7zhKikDJCQxtWRBATv1iqWf'
};
